import * as ReactDOM from 'react-dom';

function findDOMNode(componentOrElement) {
  if (componentOrElement == null) {
    return null;
  }

  if (componentOrElement instanceof Element || componentOrElement instanceof Text) {
    return componentOrElement;
  }

  const refHost = componentOrElement;
  if (refHost.current != null) {
    return findDOMNode(refHost.current);
  }

  const instance = componentOrElement;
  let fiber = instance._reactInternals ?? instance._reactInternalFiber;

  while (fiber) {
    const { stateNode } = fiber;
    if (stateNode instanceof Element || stateNode instanceof Text) {
      return stateNode;
    }
    fiber = fiber.child;
  }

  return null;
}

/**
 * React 19 removed ReactDOM.findDOMNode. Legacy dependencies (e.g. react-transition-group
 * in filter drawers) still call it when running standalone outside the Hive shell.
 */
export function applyReactDomFindDomNodePolyfill() {
  if (typeof ReactDOM.findDOMNode === 'function') {
    return;
  }

  ReactDOM.findDOMNode = findDOMNode;

  if (ReactDOM.default && typeof ReactDOM.default.findDOMNode !== 'function') {
    ReactDOM.default.findDOMNode = findDOMNode;
  }
}

applyReactDomFindDomNodePolyfill();
